import { VersionLessonRow } from '../../../types/planung-graphql-client-defs';
import { LessonTableType } from '../TimetableVersion/Table/TimetableVersionLessonsTable';

export type EntityMaps = {
  subjectByUuid: Map<string, { uuid: string; name: string; shortName: string }>;
  classsByUuid: Map<string, { uuid: string; name: string; shortName: string; grade?: number | null }>;
  teacherByUuid: Map<
    string,
    {
      uuid: string;
      displayNameShort?: string | null;
      shortName?: string | null;
      timetableConfig?: { color?: string | null } | null;
    }
  >;
  roomByUuid: Map<string, { uuid: string; name: string }>;
};

export function versionLessonRowToTableType(rows: VersionLessonRow[], entities: EntityMaps): LessonTableType[] {
  return rows.map((row): LessonTableType => {
    const subject = entities.subjectByUuid.get(row.subjectUuid);

    const classes = row.classUuids.flatMap((uuid) => {
      const c = entities.classsByUuid.get(uuid);
      return c ? [{ uuid: c.uuid, name: c.shortName, shortName: c.shortName, grade: c.grade ?? 0 }] : [];
    });

    const teachers = row.teacherUuids.map((uuid) => {
      const t = entities.teacherByUuid.get(uuid);
      return {
        uuid,
        name: t?.displayNameShort ?? t?.shortName ?? undefined,
        color: t?.timetableConfig?.color ?? null,
        teachingLoadEnabled: false,
        presenceEnabled: true,
        teachingLoadHours: undefined,
      };
    });

    const rooms = row.roomUuids.flatMap((uuid) => {
      const r = entities.roomByUuid.get(uuid);
      return r ? [{ uuid: r.uuid, name: r.name }] : [];
    });

    return {
      uuid: row.uuid,
      subject: row.subjectName ?? subject?.name ?? '',
      subjectShortName: subject?.shortName ?? '',
      subjectUuid: row.subjectUuid,
      classSort: row.classSort ?? '',
      teacherSort: row.teachersSort ?? undefined,
      classes,
      classesUuids: row.classUuids,
      teachers,
      teacherUuids: row.teacherUuids,
      elective: row.elective ?? false,
      teachingLoadEnabled: row.teachingLoadEnabled ?? false,
      timetableEnabled: row.timetableEnabled ?? false,
      onlyInTimetableVersion: row.onlyInTimetableVersion ?? false,
      lessonUnits: row.lessonUnits.map((lu) => ({
        uuid: lu.uuid,
        duration: lu.duration ?? 0,
        count: lu.count ?? 0,
        subjectContainer: lu.subjectContainerUuid
          ? (entities.subjectByUuid.get(lu.subjectContainerUuid) ?? null)
          : null,
      })),
      groupClassNames: row.groupClassNames ?? '',
      placedCardsCount: row.placedCardsCount,
      isSubjectContainerLesson: row.isSubjectContainerLesson,
      rooms,
      roomsUuids: row.roomUuids,
    };
  });
}
